export default __webpack_public_path__ + "static/media/Show.094edb14.svg";